import * as React from 'react';

import { translate } from '~l10n/client';

import {
  ListItemProps,
  QuizWorkspaceListItem,
} from '~teacher/components/QuizWorkspaceList/QuizWorkspaceListItem';

interface ListProps {
  items: ListItemProps[];
  setSelectedIds?: Set<string>;
  header?: React.ReactNode;
  parentId?: string;
}

export function QuizWorkspaceList({ items, header }: ListProps) {
  return (
    <div className="h-80 overflow-y-scroll overflow-x-hidden">
      <ol className="w-max">
        {header}
        {items?.length > 0 ? (
          items.map(
            ({ name, uniqueId, type, isSelected, onClick, isDisabled }) => (
              <QuizWorkspaceListItem
                key={uniqueId}
                uniqueId={uniqueId}
                onClick={onClick}
                name={name}
                type={type}
                isSelected={isSelected}
                isDisabled={isDisabled}
              />
            )
          )
        ) : (
          <div className="p-16 flex justify-center content-center text-md font-display">
            {translate('This folder is empty')}
          </div>
        )}
      </ol>
    </div>
  );
}
